import React from 'react';
import ServicePage from './ServicePage';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import SEOPageimage from "../assets/seo.webp"
import styled from 'styled-components';

const SEOCard = styled.div`
  flex: 0 0 43%;
  margin-bottom: 30px;
  padding: ${props => props.padding || '30px'};
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  text-align: ${props => props.align || 'left'};
  
  @media (max-width: 968px) {
    flex: 0 0 90%;
  }
  
  @media (max-width: 576px) {
    flex: 0 0 85%;
  }
  
  h4 {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 15px;
    color: #ff6e6e;
  }
  
  p {
    font-size: 15px;
    color: #666;
    line-height: 1.6;
  }
`;

const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 40px;
  
  @media (max-width: 768px) {
    justify-content: space-around;
  }
  
  @media (max-width: 576px) {
    justify-content: center;
  }
`;

const SectionTitle = styled.h3`
  font-size: 24px;
  font-weight: 600;
  margin: ${props => props.margin || '0 0 20px'};
  color: #333;
  text-align: center;
`;

const ToolsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 30px;
  
  @media (max-width: 576px) {
    gap: 15px;
  }
`;

const ToolTag = styled.div`
  padding: 15px 25px;
  background-color: #fff;
  border-radius: 30px;
  box-shadow: 0 3px 10px rgba(0,0,0,0.05);
  font-size: 14px;
  font-weight: 500;
  
  @media (max-width: 576px) {
    padding: 12px 20px;
    font-size: 13px;
  }
`;

const SEOPage = () => {
  const features = [
    'Comprehensive SEO audits and strategy development',
    'On-page optimization and content enhancement',
    'Technical SEO improvements',
    'Link building and off-page optimization',
    'Local SEO for regional businesses',
    'Regular performance reporting and analytics'
  ];

  const additionalContent = (
    <div>
      <SectionTitle>
        Our SEO Optimization Approach
      </SectionTitle>
      <CardContainer>
        <SEOCard>
          <h4>Technical SEO</h4>
          <p>
            We optimize your website's technical foundation, addressing issues like site speed, mobile-friendliness, indexability, and site architecture to ensure search engines can effectively crawl and index your content.
          </p>
        </SEOCard>
        <SEOCard>
          <h4>On-Page Optimization</h4>
          <p>
            Our team optimizes individual pages with strategic keyword placement, enhanced meta tags, improved content structure, and semantic markup to increase relevance and visibility in search results.
          </p>
        </SEOCard>
        <SEOCard>
          <h4>Content Strategy</h4>
          <p>
            We develop comprehensive content strategies that address user intent, incorporate relevant keywords, and provide valuable information that positions your brand as an authority in your industry.
          </p>
        </SEOCard>
        <SEOCard>
          <h4>Link Building</h4>
          <p>
            Our ethical link building strategies focus on acquiring high-quality backlinks from relevant and authoritative sources, enhancing your domain authority and search engine rankings.
          </p>
        </SEOCard>
      </CardContainer>
      
      <SectionTitle margin="50px 0 20px">
        SEO Tools & Technologies
      </SectionTitle>
      <ToolsContainer>
        <ToolTag>Google Analytics</ToolTag>
        <ToolTag>Google Search Console</ToolTag>
        <ToolTag>SEMrush</ToolTag>
        <ToolTag>Ahrefs</ToolTag>
        <ToolTag>Moz</ToolTag>
        <ToolTag>Screaming Frog</ToolTag>
      </ToolsContainer>
    </div>
  );

  return (
    <ServicePage
      icon={faSearch}
      title="SEO Optimization"
      subtitle="Data-driven search engine optimization strategies that improve visibility, drive organic traffic, and increase conversions."
      description={["At Zenitech Solutions, our SEO optimization services are designed to maximize your online visibility, drive organic traffic, and enhance your digital presence. Whether you're launching a corporate site, an e-commerce platform, or a custom web application, we ensure your website is optimized for search engines, combining beautiful design with high-performance functionality to achieve long-term results.",

        "Our expert team leverages proven SEO strategies, from on-page optimization to keyword research and technical SEO, ensuring your website ranks higher and performs better. We focus on building responsive, user-friendly, and SEO-optimized websites that not only captivate visitors but also convert them into loyal customers.",
        
        "With a strong emphasis on clean code, intuitive navigation, and scalable architecture, we ensure your website is not only fast and secure but also prepared for future growth. From initial concept to launch, our goal is to create websites that engage your audience and boost your search engine rankings, driving measurable success for your business."]}
      features={features}
      imagePath={SEOPageimage}
      additionalContent={additionalContent}
      featuresDesciption="We offer custom SEO optimization solutions designed to boost your online presence and drive organic traffic, tailored to your unique business needs. Our team of experts utilizes the latest strategies and best practices to ensure your website achieves higher search engine rankings, visibility, and performance — all with meticulous attention to detail."
      metaTitle="SEO Optimization Services"
      metaDescription="Our SEO optimization services provide comprehensive strategies to boost your online presence, drive organic traffic, and enhance your digital footprint. From on-page optimization to technical SEO, keyword research, and link building, we ensure your website achieves higher search engine rankings and improves your online visibility."
    />
  );
};

export default SEOPage;